import { render } from "./SalaryNewModalPopup.vue?vue&type=template&id=ce3c4880&scoped=true"
import script from "./SalaryNewModalPopup.vue?vue&type=script&lang=js"
export * from "./SalaryNewModalPopup.vue?vue&type=script&lang=js"

import "./SalaryNewModalPopup.vue?vue&type=style&index=0&id=ce3c4880&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3c4880"]])

export default __exports__